// App.js ou DashboardPage.js
import React from "react";
import DashboardLayout from "./DashboardLayout";
import Products from "./Products";

const Dashbord = () => {
  return (
    <DashboardLayout>
      {/* Ici tu mets n'importe quels composants */}
     
        <Products />
    </DashboardLayout>
  );
};

export default Dashbord;
